module.exports = __webpack_public_path__ + "static/media/excel-lg.386f8694.png";